import {useEffect, useState} from 'react';

// "Held for you" while the lease is kept alive; the counter restarts on every successful heartbeat.
export function QueueLeaseIndicator({
  renewedAt,
  held
}: {
  readonly renewedAt: number;
  // How many tasks the lease covers.
  readonly held: number;
}) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const seconds = Math.max(0, Math.floor((now - renewedAt) / 1000));
  return (
    <span
      className="text-muted-foreground inline-flex items-center gap-1.5 text-xs"
      title="Held for you while this tab is open. Renewed on every heartbeat; undecided items return to the pool when you stop.">
      <span aria-hidden className="bg-success size-2" />
      {held > 1 ? `${held} held for you` : 'Held for you'} · renewed {seconds}s ago
    </span>
  );
}
